module.exports = __webpack_public_path__ + "img/85.f075b98e.jpg";